import { ChargeStatus } from '../types'

export class ChargeSemantics {
  // All these statuses indicate that we have in some way either pre-authorized a transaction
  // already captured, or we are in the process of collecting the funds
  public static REVERTABLE_STATUSES = [
    ChargeStatus.Pending,
    ChargeStatus.Processing,
    ChargeStatus.Succeeded,
    ChargeStatus.Deferred,
  ]

  public static CAPTURED_STATUSES = [ChargeStatus.Processing, ChargeStatus.Succeeded]
}
